import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { PricingPlan } from '../pages/Pricing';

interface IProps {
  plan: PricingPlan;
  onGetStartedClicked: (code: string) => void;
}

const PricingCard: React.FC<IProps> = ({ plan, onGetStartedClicked }) => {
  // const [isHovered, setIsHovered] = React.useState(false);

  return (
    <Box
      // onMouseEnter={() => setIsHovered(true)}
      // onMouseLeave={() => setIsHovered(false)}
      sx={{
        bgcolor: 'white',
        borderRadius: 4,
        p: 'clamp(20px, 4vw, 32px) clamp(16px, 3vw, 24px)',
        boxShadow: plan.isPopular
          ? '0 8px 24px rgba(0,0,0,0.15)'
          : '0 4px 12px rgba(0,0,0,0.08)',
        // height: '100%',
        // width: '100%',
        minWidth: '70%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        transform: plan.isPopular
          ? { xs: 'scale(1)', md: 'scale(1.03)' }
          : 'scale(1)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        zIndex: plan.isPopular ? 2 : 1,
      }}
    >
      {plan.isPopular && (
        <Box
          sx={{
            position: 'absolute',
            top: -14,
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: '#5B9DD9',
            color: 'white',
            px: 'clamp(16px, 3vw, 24px)',
            py: 0.75,
            borderRadius: 5,
            fontSize: 'clamp(12px, 3vw, 16px)',
            fontWeight: 500,
            letterSpacing: 1,
            whiteSpace: 'nowrap',
          }}
        >
          MOST POPULAR
        </Box>
      )}

      <Box textAlign='center' mb='clamp(16px, 3vw, 24px)'>
        <Typography
          variant='h5'
          sx={{ fontWeight: 600, color: '#2c3e50', mb: 1 }}
        >
          {plan.title}
        </Typography>

        {plan.subtitle && (
          <Typography sx={{ color: '#2c3e50' }}>{plan.subtitle}</Typography>
        )}
      </Box>

      <Box flexGrow={1} mb='clamp(16px, 3vw, 24px)'>
        {plan.featureGroups.map((group, i) => (
          <Box key={i}>
            {i > 0 && (
              <Box
                sx={{
                  height: '1px',
                  backgroundColor: '#e0e0e0',
                  margin: 'clamp(12px, 2vw, 16px) 0',
                }}
              />
            )}

            {group.features.map((feature, j) => (
              <Box
                key={j}
                display='flex'
                alignItems='flex-start'
                mb='clamp(8px, 1.5vw, 10px)'
              >
                <Box
                  component='img'
                  src='/static/images/ic_bullet_stars.png'
                  sx={{
                    width: 20,
                    height: 20,
                    mr: 1.5,
                    mt: '3px',
                    flexShrink: 0,
                  }}
                />

                <Typography
                  sx={{
                    fontSize: 'clamp(13px, 2vw, 16px)',
                    color: '#2c3e50',
                    lineHeight: 1.5,
                  }}
                >
                  {feature.text}
                </Typography>
              </Box>
            ))}
          </Box>
        ))}
      </Box>

      <Button
        fullWidth
        sx={{
          bgcolor: '#6B9F6E',
          color: 'white',
          borderRadius: 5,
          py: 'clamp(12px, 2vw, 14px)',
          fontSize: 'clamp(14px, 2.5vw, 16px)',
          fontWeight: 600,
          textTransform: 'none',
          '&:hover': {
            bgcolor: '#5a8a5d',
          },
        }}
        onClick={() => {
          onGetStartedClicked(plan.code);
        }}
      >
        Get Started
      </Button>
    </Box>
  );
};

export default PricingCard;
